<div ngModelGroup="comboGrauInstrucao-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboGrauInstrucao
                       nome="grauInstrucao-{{data}}"
                       [itens]="dados"
                       itemDescricao="descricao"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Grau de Instrução"
                       label="Grau de Instrução"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
